import { cid } from './env.mjs';

/**
 * @module @mkt-common/shopee-common
 */
const EARN_COINS_FAQ_URL_ALL = {
    sg: 'https://help.shopee.sg/sg/s/article/How-do-I-earn-Shopee-Coins-1542975930923',
    tw: 'https://help.shopee.tw/tw/s/article/我要如何賺取蝦幣-1542986353793',
    my: 'https://help.shopee.com.my/my/s/article/How-do-I-earn-Shopee-Coins-1542971594869',
    id: 'https://help.shopee.co.id/s/article/Bagaimana-cara-mendapatkan-Koin-Shopee',
    ph: 'https://help.shopee.ph/ph/s/article/What-are-Shopee-Coins-1542962770835',
    th: 'https://help.shopee.co.th/th/s/article/Shopee-coins-%E0%B8%84%E0%B8%B7%E0%B8%AD%E0%B8%AD%E0%B8%B0%E0%B9%84%E0%B8%A3-1542966285778',
    vn: 'https://help.shopee.vn/vn/s/article/Shopee-Xu-l%C3%A0-g%C3%AC-1542942386643',
    br: 'https://help.shopee.com.br/s/article/O-que-s%C3%A3o-Moedas-do-Shopee',
    mx: 'https://help.shopee.com.mx/s/article/O-que-s%C3%A3o-Moedas-do-Shopee',
    es: 'https://help.shopee.es/s/article/O-que-s%C3%A3o-Moedas-do-Shopee',
    fr: 'https://help.shopee.fr/s/article/O-que-s%C3%A3o-Moedas-do-Shopee',
    pl: 'https://help.shopee.pl/portal/article/74092',
    in: 'https://help.shopee.in/portal/article/73261',
    ar: 'https://help.shopee.com.ar/portal/article/77748',
};
const EARN_COINS_FAQ_URL = EARN_COINS_FAQ_URL_ALL[cid];

export { EARN_COINS_FAQ_URL, EARN_COINS_FAQ_URL_ALL };
